import { Button, Text, XStack, YStack } from '@frontend/web-react';
import { concatClasses } from '@frontend/web-utils';

export type StackCardProps = {
  actionLabel?: string;
  className?: string;
  content: string;
  dismissLabel?: string;
  isActive?: boolean;
  isMobile?: boolean;
  onAction?: () => void;
  onDismiss?: () => void;
  testId?: string;
};

export const StackCard = ({
  actionLabel = 'Start Task',
  content,
  dismissLabel = 'Dismiss',
  isActive = false,
  isMobile = false,
  onAction,
  onDismiss,
  testId,
}: StackCardProps) => {
  const wrapperStyle = isActive
    ? {
        background: 'conic-gradient(from 180deg, #A2DBC6, #E5EDF7, #EEFB86, #A2DBC6)',
        borderRadius: 24,
        boxShadow: '0 4px 18px 0 rgba(0, 0, 0, 0.12)',
        padding: 3,
      }
    : { borderRadius: 24 };

  const innerStyle = isActive ? { borderRadius: 21 } : undefined;

  return (
    <div className="h-full" data-testid={testId} style={wrapperStyle}>
      <YStack
        className={concatClasses(
          'h-full justify-between bg-white p-xl',
          !isActive && 'border border-neutral-200 rounded-[24px]',
        )}
        style={innerStyle}
      >
        <YStack justifyContent="center" mb="md">
          <Text color="primary" lineClamp={2} type="p-lg">
            {content}
          </Text>
        </YStack>
        <XStack className="items-center justify-between gap-md">
          <Button label={dismissLabel} onClick={onDismiss} size={isMobile ? 'md' : 'lg'} variant="secondary" />
          <Button label={actionLabel} onClick={onAction} size={isMobile ? 'md' : 'lg'} variant="gradient" />
        </XStack>
      </YStack>
    </div>
  );
};
